import React, { FC, Ref, CSSProperties } from 'react';

import styled from 'styled-components';

import { Modal, ModalApi, ModalProps } from '@components/Modal';
import { CheckCircle } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
`;

const Label = styled.span`
  margin: 40px 0 20px;
  font-size: 23px;
  font-weight: 600;
  color: ${(p) => p.theme.palette.darkGrey};
  text-align: center;
`;

const Message = styled.span`
  margin-bottom: 40px;
  color: ${(p) => p.theme.palette.darkGray};
  font-size: 16px;
  line-height: 1.56;
  text-align: center;
`;

const staticProps = {
  width: 455,
  title: null,
};

type Props = {
  modal?: Ref<ModalApi>;
  onCancel?: () => void;
  message?: React.ReactNode;
  ContentComponent?: React.ComponentType | React.ElementType;
  contentStyle?: CSSProperties;
  renderContentMessage?: (
    message: React.ReactNode,
    children: React.ReactNode,
    MessageContainer: React.ComponentType<React.PropsWithChildren<unknown>>
  ) => React.ReactNode;
} & ModalProps;

const defaultRenderer: Props['renderContentMessage'] = (
  message,
  children,
  MessageContainer
) => (
  <>
    {message ? <MessageContainer>{message}</MessageContainer> : null}
    {children}
  </>
);

const SuccessModal: FC<Props> = ({
  modal,
  isVisible,
  onCancel,
  title = '',
  message = '',
  ContentComponent = Content,
  contentStyle,
  children,
  renderContentMessage = defaultRenderer,
  ...rest
}) => {
  return (
    <Modal
      isVisible={isVisible}
      onCancel={onCancel}
      ref={modal}
      {...staticProps}
      {...rest}
    >
      <ContentComponent style={contentStyle}>
        <CustomIcon icon={CheckCircle} fontSize={100} />
        <Label>{title}</Label>
        {renderContentMessage(message, children, Message)}
      </ContentComponent>
    </Modal>
  );
};

export default SuccessModal;
